module.exports = __webpack_public_path__ + "assets/d6f9ded049654053015e0d05211f4fa3.svg";